import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={15}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 8.938A4.22 4.22 0 0 0 7.5.5a4.22 4.22 0 0 0 0 8.438Zm3.75.937H9.636a5.106 5.106 0 0 1-4.272 0H3.75A3.75 3.75 0 0 0 0 13.625v.469C0 14.87.63 15.5 1.406 15.5h12.188c.776 0 1.406-.63 1.406-1.406v-.469a3.75 3.75 0 0 0-3.75-3.75Z"
      fill="var(--club-car-gold-bg)"
    />
  </svg>
);

export default SvgComponent;
